import React from 'react';
import { useParams, useLocation } from 'react-router';
import { Redirect } from 'react-router-dom';
import { useMakeFilteredUrl } from '@/hooks/useFilter';

const QRHandlerPage = () => {
  const { version } = useParams<{ version: string }>();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const action = queryParams.get('action');
  const machine_id = queryParams.get('machine_id');
  const make = useMakeFilteredUrl();

  console.log(`QR code ${version}`);

  switch (action) {
    case 'view':
    default:
      return <Redirect to={make(`/machine/${machine_id}/reports`)} />;
  }
};
export default QRHandlerPage;
